module.exports = __webpack_public_path__ + "img/4_ru.0b694a9c.webp";